import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import {
    StoreType,
    ChangeUserSettings,
    updateUserSettings,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    CKEditor,
    FileLoader,
    Delimiter,
} from "client/components"

import ProjectModules from "client/pages/project/project/edit/modules"

const DefaultUserSettings = () => {
    const settings = useSelector((state: StoreType) => state.userSettings.settings.project)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const onChange = (value: ChangeUserSettings) => {
        dispatch(updateUserSettings("project", value))
    }

    const {
        defaultPublicId,
        defaultName,
        defaultDescription,
        defaultLogo,
        defaultModules,
    } = settings

    return (
        <PageForm style={{ paddingBottom: 0 }}>
            <Row>
                <Col xs={12} md={4}>
                    <FormGroup>
                        <Label>{lang.defaultPublicId}</Label>
                        <Input
                            type="text"
                            value={defaultPublicId}
                            onChange={(e) => onChange({ defaultPublicId: e.target.value })}
                        />
                    </FormGroup>
                </Col>
                <Col xs={12} md={8}>
                    <FormGroup>
                        <Label>{lang.defaultName}</Label>
                        <Input
                            type="text"
                            value={defaultName}
                            onChange={(e) => onChange({ defaultName: e.target.value })}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.defaultDescription}</Label>
                        <CKEditor
                            data={defaultDescription}
                            onChange={(data) => onChange({ defaultDescription: data })}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.defaultImage}</Label>
                        <FileLoader
                            value={defaultLogo}
                            callback={(file) => onChange({
                                defaultLogoId: file.id,
                                defaultLogo: file,
                            })}
                        />
                    </FormGroup>
                    <Delimiter />

                    <ProjectModules
                        activeModules={defaultModules}
                        onChange={(value) => onChange({ defaultModules: value })}
                        title={lang.defaultAssignedModules}
                    />
                    <Delimiter size="sm" />
                </Col>
            </Row>
        </PageForm>
    )
}
export default DefaultUserSettings
